import api from "./api";

// 更新文章头图和引流图
export const updateArticleHeaderDrainage = async ({
  agentId,
  userId,
  articleHeaderCopy,
  articleDrainageImage,
}: {
  agentId: string;
  userId: string;
  articleHeaderCopy: string;
  articleDrainageImage: string;
}) => {
  const res = await api.post<unknown>("/push_info_user_subscription_setting/update-article-header-drainage", {
    agent_id: agentId,
    user_id: userId,
    article_header_copy: articleHeaderCopy,
    article_drainage_image: articleDrainageImage,
  });
  return res;
};
